import React from 'react';
import './Statistics.css';
import { useIsMobile } from '../../hooks/useMediaQuery';

const stats = [
  {
    value: "10-15x",
    description: "faster legal research and case strategy formulation"
  },
  {
    value: "70%",
    description: "increase in document retrieval speed with AI search and auto-tagging"
  },
  {
    value: "80%",
    description: "of legal operations automated with modular AI blocks"
  },
  {
    value: "95%",
    description: "plus accuracy in semantic legal search retrieval"
  },
  {
    value: "30-50%",
    description: "reduction in compliance risks through proactive monitoring"
  },
  {
    value: "500K+",
    description: "legal documents indexed and auto-summarized for smarter knowledge bases"
  },
  {
    value: "40-60%",
    description: "faster contract drafting and approvals with AI Copilots"
  }
];

const Separator = () => (
  <img src="/images/separator.svg" alt="|" className="stat-separator" />
);

const Statistics = () => {
  const isMobile = useIsMobile();
  if (!isMobile) {
    return (
      <div className="statistics-container">
        <div className="statistics-row top-row">
          {stats.slice(0, 4).map((stat, idx) => (
            <React.Fragment key={stat.value + idx}>
              <div className="stat-item top-stat">
                <span className="stat-value">{stat.value}</span>
                <span className="stat-description">{stat.description}</span>
              </div>
              {idx < 3 && <Separator />}
            </React.Fragment>
          ))}
        </div>
        <div className="statistics-row bottom-row">
          {stats.slice(4).map((stat, idx) => (
            <React.Fragment key={stat.value + idx}>
              <div className="stat-item bottom-stat">
                <span className="stat-value">{stat.value}</span>
                <span className="stat-description">{stat.description}</span>
              </div>
              {idx < 2 && <Separator />}
            </React.Fragment>
          ))}
        </div>
      </div>
    );
  } else {
    return (
      <div className="statistics-container">
        {stats.slice(0, 6).map((item, index) => (
          <div key={index} className="stats-card half-width">
            <span className="stat-value">{item.value}</span>
            <span className="stat-description">{item.description}</span>
          </div>
        ))}
        <div className="stats-card full-width">
          <span className="stat-value">{stats[6].value}</span>
          <span className="stat-description">{stats[6].description}</span>
        </div>
      </div>

    );
  }
};

export default Statistics;